import React, { PureComponent } from 'react';

class DataListPromotor extends PureComponent {

    /**
     * 
     * @param {any} event
     * @param {any} promotores
     */
    handleValue(event, promotores) {
        let term = event.target.value;
        const { data, seleccionarCombo } = this.props;

        if (term.length > 2) {
            let obj = promotores.find(x => x.Nombre == term);
            if (obj) {
                seleccionarCombo(obj.Id, "PROMOTOR", obj.Nombre)
            }
        }
    }

    render() {

        const { GET_PROMOTOR } = this.props;

        const promotorNodes = GET_PROMOTOR.map((promotor, index) => {
            return (
                <option value={promotor.Nombre} key={"promotor-usuario-" + index} />
            );
        })

        return (
        <div id="promotorContainer">
            <div className="input-icon-container">
               <span className="ti-search input-icon-span"></span>
               <input
                  list="listPromotor"
                  id="promotorName"
                  name="promotorName"
                  className="form-control input-with-icon jqvalid"
                  placeholder="Buscar por nombre"
                  onChange={(evt) => this.handleValue(evt, GET_PROMOTOR)}
                  required
                />
                <datalist id="listPromotor">
                  {promotorNodes}
                </datalist>
            </div>
        </div>
        );
    }
}

export default DataListPromotor;